export { Skeleton } from "./Skeleton";
export * from "./Skeleton.config";
